import { useLazyQuery } from '@apollo/client';
import React, { useContext, useEffect } from 'react'
import { GET_STRIPE_PAYOUT_ERROR, GET_STRIPE_PAYOUT_SUCCESS } from '../../../features/ErrorDashboard/api/ErrorQuery';
import ToasterWithMessage from '../toaster';
import { CircularProgress } from '@mui/material';
import styles from './StripePaymentsError.module.css';
import AppTable from '../table/AppTable';
import moment from 'moment';
import { formatDates } from '../../../helper';
import { globalContext } from '../../../Provider/AppProvider';

const StripePayoutError = (props: any) => {
  const {
          rowsPerPageStripepayout,
          currentPageStripepayout,
          setCurrentPageStripepayout,
          checking,
          setChecking,
          stripePaymentsErrorpayoutList,
          setStripePaymentspayoutErrorList,
          columnTypes,
          setColumnTypes,
          sortType,
          setSortType,
          selected,
          setSelected,
          datesForApiCall,
          selectedStartDate,
          selectedEndDate,
          GenerateStripePayoutErrorHeadCells,
          handleChangeRowsPerPageForStripepayout,
          handlePageChangeStripepayout,
          setDatesForApiCallForStripepayoutError
  } = props;
  const {error} = ToasterWithMessage();
  const {globalState} = useContext<any>(globalContext)
  const [getStripePayoutErrorData,{loading}] = useLazyQuery(GET_STRIPE_PAYOUT_ERROR,{
    fetchPolicy: 'no-cache',
    onCompleted: (stripeData) => {
      setStripePaymentspayoutErrorList(stripeData);
    },
    onError: (err) => {
      error("Something went wrong while fetching error data!")
    }
  })
  const [getStripePayoutSuccessData,{loading:successLoading}] = useLazyQuery(GET_STRIPE_PAYOUT_SUCCESS,{
    fetchPolicy: 'no-cache',
    onCompleted: (stripeData) => {
      setStripePaymentspayoutErrorList(stripeData);
    },
    onError: (err) => {
      error("Something went wrong while fetching success data!")
    }
  })

  const callStripePayoutErrorApi = () => {
    const startdateForStripe = datesForApiCall.fromdate
    const enddateForStripe = datesForApiCall.enddate
    const payloadEndDateForStripe = moment(datesForApiCall.enddate,'YYYY-MM-DD').add(1,'days');
    const formattedDates = formatDates(startdateForStripe, enddateForStripe);
    if(moment(startdateForStripe).isSameOrBefore(enddateForStripe,'day')){
      if(globalState.errorStatus.stripePayout==="Failed"){
        getStripePayoutErrorData({
          variables: {
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate,
            limit: rowsPerPageStripepayout,
            offset: (currentPageStripepayout -1)*rowsPerPageStripepayout,
            order_by: (columnTypes === 'u_first_name') || (columnTypes === 'u_email_id')  || (columnTypes === 'u_last_name')
                    ? {user: {[columnTypes]: sortType} } 
                      : {[columnTypes]: sortType}
          
          }
        })
      }else if(globalState.errorStatus.stripePayout==="Success"){
        getStripePayoutSuccessData({
          variables: {
            startDate: formattedDates.formattedStartDate,
            endDate: formattedDates.formattedEndDate,
            limit: rowsPerPageStripepayout,
            offset: (currentPageStripepayout -1)*rowsPerPageStripepayout,
            order_by: (columnTypes === 'u_first_name') || (columnTypes === 'u_email_id')  || (columnTypes === 'u_last_name')
                    ? {user: {[columnTypes]: sortType} } 
                      : {[columnTypes]: sortType}
          }
        })
      }
        return;
    }else {
        // error("Fromdate must be less than todate");
        return;
    }
  };
  
  useEffect(() => {
    callStripePayoutErrorApi();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedStartDate,
     selectedEndDate,
     sortType,
     columnTypes,
     rowsPerPageStripepayout,
     currentPageStripepayout,
     globalState.errorStatus.stripePayout
    ]);


  return (
    <>
      {
        loading || successLoading
      ?
        <div className={styles.TableCircularProgress}>
        <CircularProgress color="primary" size={35} />
        </div>
      :
      <AppTable
        handleChangeRowsPerPage={handleChangeRowsPerPageForStripepayout}
        handlePageChange={handlePageChangeStripepayout}
        setColumnTypes={setColumnTypes}
        sortType={sortType}
        setSortType={setSortType}
        setChecking={setChecking}
        checking={checking}
        rowsPerPage={rowsPerPageStripepayout}
        setCurrentPage={setCurrentPageStripepayout}
        currentPage={currentPageStripepayout}
        list={stripePaymentsErrorpayoutList}
        // list={dummyStripeErrorData}
        tableTitle={globalState.errorStatus.stripePayout==="Failed"?"stripePayoutError":"stripePayoutSuccess"}
        selected={selected}
        setSelected={setSelected}
        generateHeadCells={GenerateStripePayoutErrorHeadCells}
      />
      }
    </>
  )
}

export default StripePayoutError